import { render, staticRenderFns } from "./add-patient.vue?vue&type=template&id=6283ee36&scoped=true&"
import script from "./add-patient.vue?vue&type=script&lang=ts&"
export * from "./add-patient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283ee36",
  null
  
)

export default component.exports